var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"thumbnail square rounded",style:(_vm.figureStyles),on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[(_vm.species.thumbnailUrl)?_c('img',{attrs:{"src":_vm.species.thumbnailUrl,"alt":_vm.altDescription}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }